import { Close, Content, Overlay, Portal, Root } from "@radix-ui/react-dialog";
import { Cross, Hamburger } from "@ruter-ds-next/icons";
import React from "react";

import "./style.css?__remix_sideEffect__";

const ANIMATION_DURATION = 200;

export function MobileNavigationMenu({
  open,
  children,
  className = "",
  onOpenChange,
  ...props



}: {open: boolean;onOpenChange: (open: boolean) => void;} & React.ComponentPropsWithoutRef<typeof Content>) {
  const [timer, setTimer] = React.useState(false);
  React.useEffect(() => {
    if (open === true) {
      setTimer(true);
    } else if (timer) {
      const ref = setTimeout(() => setTimer(false), ANIMATION_DURATION);

      return function () {
        clearTimeout(ref);
      };
    }
  }, [open, timer]);

  return (
    <Root open={timer} onOpenChange={onOpenChange}>
      <button onClick={() => onOpenChange(true)}>
        <Hamburger className="size-8" />
      </button>
      <Portal>
        <Overlay className="mobile-navigation-menu-overlay">
          <div className="mobile-navigation-menu-content-wrapper">
            <Content
              className={`mobile-navigation-menu-content ${
              open ? "open" : "closed"
              }`}
              {...props}>

              <Close className="mobile-navigation-menu-close-button">
                <Cross className="size-8" />
              </Close>
              <div className={className}>{children}</div>
            </Content>
          </div>
        </Overlay>
      </Portal>
    </Root>);

}